"use strict";
exports.__esModule = true;
exports.getPreviewState = exports.isVideo = exports.getVideoDimension = exports.getImageDimension = void 0;
var SlideGenerator_1 = require("./SlideGenerator");
var getImageDimension = function (url) {
    if (!window.imageCache) {
        window.imageCache = {};
    }
    if (window.imageCache[url] && window.imageCache[url] !== '') {
        Promise.resolve(window.imageCache[url]);
    }
    var wait = function (ms) { return new Promise(function (r) { return setTimeout(r, ms); }); };
    var retryOperation = function (operation, delay, times) {
        return new Promise(function (resolve, reject) {
            return operation()
                .then(resolve)["catch"](function (reason) {
                if (times - 1 > 0) {
                    return wait(delay)
                        .then(retryOperation.bind(null, operation, delay, times - 1))
                        .then(resolve)["catch"](reject);
                }
                return reject(reason);
            });
        });
    };
    return new Promise(function (resolve) {
        if (!window) {
            resolve(null);
            return;
        }
        if (window.imageCache[url] === '') {
            retryOperation(function () {
                if (window.imageCache[url] !== '') {
                    return Promise.resolve(window.imageCache[url]);
                }
                return Promise.reject();
            }, 500, 10).then(function () {
                resolve(window.imageCache[url]);
            });
            return;
        }
        window.imageCache[url] = '';
        var image = new Image();
        image.onload = function () {
            var size = { width: image.width, height: image.height };
            window.imageCache[url] = size;
            resolve(size);
        };
        image.src = url;
    });
};
exports.getImageDimension = getImageDimension;
var getVideoDimension = function (url) {
    return new Promise(function (resolve) {
        if (!window) {
            resolve(null);
            return;
        }
        var video = document.createElement('video');
        var mobileFallback = null;
        video.style.display = 'none';
        video.addEventListener('loadedmetadata', function () {
            if (mobileFallback) {
                clearTimeout(mobileFallback);
                mobileFallback = null;
            }
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
        });
        mobileFallback = setTimeout(function () {
            resolve({
                width: 1920,
                height: 1080
            });
        }, 1000);
        video.src = url;
    });
};
exports.getVideoDimension = getVideoDimension;
var isVideo = function (src) {
    var ext = src.split('.').pop().toLowerCase();
    var imgExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
    if (imgExts.indexOf(ext) >= 0)
        return false;
    return true;
};
exports.isVideo = isVideo;
var constraintIndex = function (total, min, max) {
    return [
        min < 0 ? 0 : min,
        max > total - 1 ? total - 1 : max,
    ];
};
var getPreviewState = function (originIndex, film, delta) {
    var range = (0, SlideGenerator_1.getVisibleIndexes)(film, delta);
    var previewRange = constraintIndex(film.slideItems.length, range[0] - 1, range[1] + 1);
    var rangeIndexes = film.slideItems
        .filter(function (it, i) { return i >= range[0] && i <= range[1]; })
        .map(function (it) { return it.originIndex; });
    var previewIndexes = film.slideItems
        .filter(function (it, i) { return i >= previewRange[0] && i <= previewRange[1]; })
        .map(function (it) { return it.originIndex; });
    // determine which slide should preload nothing
    if (previewIndexes.indexOf(originIndex) < 0) {
        return { seen: false, preview: false };
    }
    // determine which slide should preload src
    if (rangeIndexes.indexOf(originIndex) >= 0) {
        return { seen: true, preview: true };
    }
    return { seen: false, preview: true };
};
exports.getPreviewState = getPreviewState;
